{
  "visitorManagement": {
    "title": "Zarządzanie odwiedzającymi",
    "description": "Wyświetl i zarządzaj stanami synchronizacji dostawców odwiedzających",
    "filters": {
      "bookingId": "ID rezerwacji",
      "vendor": "Dostawca",
      "syncStatus": "Status synchronizacji",
      "all": "Wszystkie",
      "synced": "Zsynchronizowane",
      "failed": "Nieudane",
      "unknown": "Nieznane",
      "search": "Wyszukaj według nazwy kontaktu"
    },
    "table": {
      "bookingId": "ID rezerwacji",
      "contact": "Kontakt",
      "dates": "Daty",
      "status": "Status",
      "note": "Notatka",
      "bookingDetails": "Szczegóły rezerwacji",
      "vendor": "Dostawca",
      "syncStatus": "Status synchronizacji",
      "actions": "Akcje",
      "forceSync": "Wymuś synchronizację",
      "viewDetails": "Wyświetl szczegóły",
      "noData": "Nie znaleziono stanów dostawców odwiedzających",
      "loading": "Ładowanie...",
      "validation": "Walidacja",
      "mirror": "Lustro",
      "lastSync": "Ostatnia synchronizacja"
    },
    "status": {
      "synced": "Zsynchronizowane",
      "failed": "Nieudane",
      "unknown": "Nieznane",
      "registered": "Zarejestrowane",
      "notRegistered": "Niezarejestrowane"
    },
    "detail": {
      "title": "Szczegóły synchronizacji dostawcy",
      "syncDetails": "Szczegóły synchronizacji",
      "vendor": "Dostawca",
      "syncStatus": "Status synchronizacji",
      "lastContacted": "Ostatni kontakt",
      "lastSuccessful": "Ostatnia udana synchronizacja",
      "lastFailed": "Ostatnia nieudana synchronizacja",
      "errorMessage": "Komunikat błędu",
      "lastSuccessfulRequest": "Ostatnie udane żądanie",
      "lastSuccessfulResponse": "Ostatnia udana odpowiedź",
      "lastFailedRequest": "Ostatnie nieudane żądanie",
      "lastFailedResponse": "Ostatnia nieudana odpowiedź",
      "never": "Nigdy",
      "close": "Zamknij",
      "forceSyncTooltip": "Funkcja wymuszonej synchronizacji wkrótce"
    },
    "empty": {
      "noStates": {
        "title": "Brak stanów dostawców",
        "description": "Żadne rezerwacje nie zostały jeszcze zsynchronizowane z dostawcami zarządzania odwiedzającymi."
      },
      "noResults": {
        "title": "Nie znaleziono wyników",
        "description": "Spróbuj dostosować filtry, aby znaleźć to, czego szukasz."
      },
      "noPermission": {
        "title": "Dostęp zabroniony",
        "description": "Nie masz uprawnień do przeglądania danych zarządzania odwiedzającymi. Skontaktuj się z administratorem."
      }
    },
    "error": {
      "title": "Błąd ładowania stanów dostawców odwiedzających",
      "description": "Nie udało się załadować stanów dostawców odwiedzających. Spróbuj ponownie."
    }
  }
}
